import React, { useState, useEffect } from 'react';
import './FormularioPedido.css';

const FormularioPedido = ({ choferes = [], onSubmit, onCancel, modo = 'completo', pedidoEditar = null }) => {
  const [formData, setFormData] = useState({
    numeroDocumento: '',
    fechaCompra: '',
    fechaEntrega: '',
    importe: '',
    tipoPago: '',
    chofer: '',
    telefonoCliente: '',
    calle: '',
    colonia: '',
    codigoPostal: '',
    direccion: '',
    direccionCompleta: '',
    coloniaCajas: '',
    calleCajas: '',
    numeroCajas: '',
    referencias: '',
    comentarios: '',
    estatus: 'en_preparacion',
    cliente: ''
  });

  // Pre-llenar el formulario si se está editando un pedido
  useEffect(() => {
    if (pedidoEditar) {
      setFormData({
        numeroDocumento: pedidoEditar.numeroDocumento || '',
        fechaCompra: pedidoEditar.fechaCompra || '',
        fechaEntrega: pedidoEditar.fechaEntrega || '',
        importe: pedidoEditar.importe || '',
        tipoPago: pedidoEditar.tipoPago || '',
        chofer: pedidoEditar.chofer || '',
        telefonoCliente: pedidoEditar.telefonoCliente || '',
        calle: pedidoEditar.calle || '',
        colonia: pedidoEditar.colonia || '',
        codigoPostal: pedidoEditar.codigoPostal || '',
        direccion: pedidoEditar.direccion || '',
        direccionCompleta: pedidoEditar.direccionCompleta || '',
        coloniaCajas: pedidoEditar.coloniaCajas || '',
        calleCajas: pedidoEditar.calleCajas || '',
        numeroCajas: pedidoEditar.numeroCajas || '',
        referencias: pedidoEditar.referencias || '',
        comentarios: pedidoEditar.comentarios || '',
        estatus: pedidoEditar.estatus || 'en_preparacion',
        cliente: pedidoEditar.cliente || ''
      });
    } else {
      // Resetear el formulario si no hay pedido para editar
      setFormData({
        numeroDocumento: '',
        fechaCompra: '',
        fechaEntrega: '',
        importe: '',
        tipoPago: '',
        chofer: '',
        telefonoCliente: '',
        calle: '',
        colonia: '',
        codigoPostal: '',
        direccion: '',
        direccionCompleta: '',
        coloniaCajas: '',
        calleCajas: '',
        numeroCajas: '',
        referencias: '',
        comentarios: '',
        estatus: 'en_preparacion',
        cliente: ''
      });
    }
  }, [pedidoEditar]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const direccionCompuesta = [formData.calle, formData.colonia, formData.codigoPostal]
      .filter(Boolean)
      .join(', ');
    const payload = {
      ...formData,
      direccion: formData.direccion || direccionCompuesta
    };
    if (modo === 'cajas') {
      // Para cajas, normalizar datos mínimos
      payload.estatus = 'en_preparacion';
      payload.fechaEntrega = payload.fechaEntrega || payload.fechaCompra;
      payload.chofer = payload.chofer || '';
      // Combinar coloniaCajas, calleCajas y numeroCajas en direccionCompleta
      const direccionCompletaCajas = [
        payload.coloniaCajas,
        payload.calleCajas,
        payload.numeroCajas
      ].filter(Boolean).join(', ');
      payload.direccionCompleta = direccionCompletaCajas;
      payload.direccion = direccionCompletaCajas;
      // Limpiar campos no usados
      delete payload.calle;
      delete payload.colonia;
      delete payload.codigoPostal;
      delete payload.comentarios;
      delete payload.departamento;
    }
    onSubmit(payload);
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{pedidoEditar ? 'Editar Pedido' : 'Registrar Nuevo Pedido'}</h2>
          <button className="close-button" onClick={handleCancel}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="formulario-pedido">
          {modo === 'cajas' ? (
            <>
              {/* Sección 1: Información del Pedido */}
              <div className="form-section">
                <h3 className="form-section-title">Información del Pedido</h3>
                <div className="form-row two-columns">
                  <div className="form-group">
                    <label htmlFor="numeroDocumento">Número de Pedido *</label>
                    <input
                      type="text"
                      id="numeroDocumento"
                      name="numeroDocumento"
                      value={formData.numeroDocumento}
                      onChange={handleInputChange}
                      required
                      placeholder="Ej: C82411"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="fechaCompra">Fecha del Pedido *</label>
                    <input
                      type="date"
                      id="fechaCompra"
                      name="fechaCompra"
                      value={formData.fechaCompra}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="form-row two-columns">
                  <div className="form-group">
                    <label htmlFor="importe">Monto Total *</label>
                    <input
                      type="number"
                      id="importe"
                      name="importe"
                      value={formData.importe}
                      onChange={handleInputChange}
                      required
                      step="0.01"
                      min="0"
                      placeholder="1250.50"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="tipoPago">Método de Pago *</label>
                    <select
                      id="tipoPago"
                      name="tipoPago"
                      value={formData.tipoPago}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Seleccionar...</option>
                      <option value="Tarjeta">Tarjeta</option>
                      <option value="Efectivo">Efectivo</option>
                      <option value="Transferencia">Transferencia</option>
                      <option value="Crédito">CRÉDITO</option>
                      <option value="Por cobrar">Por cobrar</option>
                      <option value="Por anticipo">Por anticipo</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Sección 2: Información del Cliente */}
              <div className="form-section">
                <h3 className="form-section-title">Información del Cliente</h3>
                <div className="form-row full-width">
                  <div className="form-group">
                    <label htmlFor="cliente">Nombre Completo del Cliente *</label>
                    <input
                      type="text"
                      id="cliente"
                      name="cliente"
                      value={formData.cliente}
                      onChange={handleInputChange}
                      required
                      placeholder="Ej: Juan Pérez García"
                    />
                  </div>
                </div>
                <div className="form-row two-columns">
                  <div className="form-group">
                    <label htmlFor="telefonoCliente">Teléfono de Contacto *</label>
                    <input
                      type="tel"
                      id="telefonoCliente"
                      name="telefonoCliente"
                      value={formData.telefonoCliente}
                      onChange={handleInputChange}
                      required
                      placeholder="Ej: 55 1234 5678"
                    />
                  </div>
                </div>
                <div className="form-row three-columns">
                  <div className="form-group">
                    <label htmlFor="coloniaCajas">Colonia *</label>
                    <input
                      type="text"
                      id="coloniaCajas"
                      name="coloniaCajas"
                      value={formData.coloniaCajas}
                      onChange={handleInputChange}
                      required
                      placeholder="Ej: Centro"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="calleCajas">Calle *</label>
                    <input
                      type="text"
                      id="calleCajas"
                      name="calleCajas"
                      value={formData.calleCajas}
                      onChange={handleInputChange}
                      required
                      placeholder="Ej: Madero"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="numeroCajas">Número *</label>
                    <input
                      type="text"
                      id="numeroCajas"
                      name="numeroCajas"
                      value={formData.numeroCajas}
                      onChange={handleInputChange}
                      required
                      placeholder="Ej: 10"
                    />
                  </div>
                </div>
                <div className="form-row full-width">
                  <div className="form-group">
                    <label htmlFor="referencias">Referencias para Identificar el Domicilio *</label>
                    <textarea
                      id="referencias"
                      name="referencias"
                      value={formData.referencias}
                      onChange={handleInputChange}
                      required
                      rows="3"
                      placeholder="Ej: Casa verde, portón negro, entre calle X y calle Y"
                    />
                  </div>
                </div>
              </div>

              {/* Botones de acción */}
              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={handleCancel}>
                  Cancelar
                </button>
                <button type="submit" className="btn-submit">
                  {pedidoEditar ? 'Guardar Cambios' : 'Registrar Pedido'}
                </button>
              </div>
            </>
          ) : (
            // MODO COMPLETO
            <>
              {/* Sección 1: Información del Pedido */}
              <div className="form-section">
                <h3 className="form-section-title">Información del Pedido</h3>
                <div className="form-row two-columns">
                  <div className="form-group">
                    <label htmlFor="numeroDocumento">Número de Pedido *</label>
                    <input
                      type="text"
                      id="numeroDocumento"
                      name="numeroDocumento"
                      value={formData.numeroDocumento}
                      onChange={handleInputChange}
                      required
                      placeholder="Ej: PED-001"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="cliente">Nombre Completo del Cliente *</label>
                    <input
                      type="text"
                      id="cliente"
                      name="cliente"
                      value={formData.cliente}
                      onChange={handleInputChange}
                      required
                      placeholder="Ej: Juan Pérez García"
                    />
                  </div>
                </div>
                <div className="form-row two-columns">
                  <div className="form-group">
                    <label htmlFor="fechaCompra">Fecha del Pedido *</label>
                    <input
                      type="date"
                      id="fechaCompra"
                      name="fechaCompra"
                      value={formData.fechaCompra}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="fechaEntrega">Fecha de Entrega Estimada *</label>
                    <input
                      type="date"
                      id="fechaEntrega"
                      name="fechaEntrega"
                      value={formData.fechaEntrega}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Sección 2: Detalles del Pedido */}
              <div className="form-section">
                <h3 className="form-section-title">Detalles del Pedido</h3>
                <div className="form-row two-columns">
                  <div className="form-group">
                    <label htmlFor="importe">Monto Total *</label>
                    <input
                      type="number"
                      id="importe"
                      name="importe"
                      value={formData.importe}
                      onChange={handleInputChange}
                      required
                      step="0.01"
                      min="0"
                      placeholder="1250.50"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="chofer">Asignar Chofer *</label>
                    <select
                      id="chofer"
                      name="chofer"
                      value={formData.chofer}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Seleccionar chofer</option>
                      {choferes.map(chofer => (
                        <option key={chofer.id} value={`${chofer.nombre} ${chofer.apellido || ''}`.trim()}>
                          {chofer.nombre} {chofer.apellido || ''}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-row two-columns">
                  <div className="form-group">
                    <label htmlFor="telefonoCliente">Teléfono de Contacto *</label>
                    <input
                      type="tel"
                      id="telefonoCliente"
                      name="telefonoCliente"
                      value={formData.telefonoCliente}
                      onChange={handleInputChange}
                      required
                      placeholder="Ej: 55 1234 5678"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="estatus">Estatus del Pedido *</label>
                    <select
                      id="estatus"
                      name="estatus"
                      value={formData.estatus}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="en_preparacion">En Preparación</option>
                      <option value="ruta">En Ruta</option>
                      <option value="entregado">Entregado</option>
                      <option value="cancelado">Cancelado</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Sección 3: Dirección de Envío */}
              <div className="form-section">
                <h3 className="form-section-title">Dirección de Envío</h3>
                <div className="form-row three-columns">
                  <div className="form-group">
                    <label htmlFor="calle">Calle y Número *</label>
                    <input
                      type="text"
                      id="calle"
                      name="calle"
                      value={formData.calle}
                      onChange={handleInputChange}
                      required
                      placeholder="Calle y número (Ej: Madero 10)"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="colonia">Colonia/Barrio *</label>
                    <input
                      type="text"
                      id="colonia"
                      name="colonia"
                      value={formData.colonia}
                      onChange={handleInputChange}
                      required
                      placeholder="Colonia/Barrio"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="codigoPostal">Código Postal *</label>
                    <input
                      type="text"
                      id="codigoPostal"
                      name="codigoPostal"
                      value={formData.codigoPostal}
                      onChange={handleInputChange}
                      required
                      placeholder="C.P. (Ej: 06000)"
                    />
                  </div>
                </div>
                <div className="form-row full-width">
                  <div className="form-group">
                    <label htmlFor="direccion">Dirección Completa (Opcional)</label>
                    <textarea
                      id="direccion"
                      name="direccion"
                      value={formData.direccion}
                      onChange={handleInputChange}
                      rows="3"
                      placeholder="Dirección completa (opcional, se compone automáticamente al guardar si los campos anteriores están llenos)"
                    />
                  </div>
                </div>
              </div>

              {/* Sección 4: Comentarios Adicionales */}
              <div className="form-section">
                <h3 className="form-section-title">Comentarios Adicionales</h3>
                <div className="form-row full-width">
                  <div className="form-group">
                    <label htmlFor="comentarios">Instrucciones Especiales</label>
                    <textarea
                      id="comentarios"
                      name="comentarios"
                      value={formData.comentarios}
                      onChange={handleInputChange}
                      rows="3"
                      placeholder="Ej: Entregar sólo por las mañanas, llamar 15 minutos antes."
                    />
                  </div>
                </div>
              </div>

              {/* Botones de acción */}
              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={handleCancel}>
                  Cancelar
                </button>
                <button type="submit" className="btn-submit">
                  {pedidoEditar ? 'Guardar Cambios' : 'Registrar Pedido'}
                </button>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default FormularioPedido;